// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__LYkqC","icon":"style_icon__MidSK"};